import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import HeyBOLogo from "../../../assets/images/HeyBO_Logo.png";
import HomeIcon from "../../../assets/images/Homepage/Header/HomeIcon.svg";
import InActiveHomeIcon from "../../../assets/images/Homepage/Header/InActiveHomeIcon.svg";
import ExploreIcon from "../../../assets/images/Homepage/Header/ExploreIcon.svg";
import ActiveExploreIcon from "../../../assets/images/Homepage/Header/ActiveExploreIcon.svg";
import CartBagIcon from "../../../assets/images/Homepage/Header/CartBagIcon.svg";
import LoginIcon from "../../../assets/images/Homepage/Header/LoginIcon.svg";
import ExploreSearch from "../../../assets/images/explore-search.svg";
import ClearSearch from "../../../assets/images/clear-search.svg";
import MenuProfile from "../../../assets/images/menu-profile.svg";
import AiSeacrhIcon from "../../../assets/images/Homepage/Header/AiSearchIcon.svg";
import Spiner from "../../../assets/images/buttonSpinner.png";
import { Link, useNavigate } from "react-router-dom";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext, { userLogout } from "../../../contexts/UserContext";
import StandardsContext from "../../../contexts/StandardsContext";
import AppContext from "../../../contexts/AppContext";
import * as Library from "../../../utils/Library";
import logGA4Event from "../../../utils/firebase/analytics";
import MenuPanel from "./MenuPanel";
import SearchWindow from "./SearchWindow";
import { Tooltip } from "antd";

const StyledPage = styled.div`
    &.transparent-header-homepage-only,
    &.transparent-header-homepage-only * {
        box-sizing: border-box;
    }
    &.transparent-header-homepage-only {
        background: rgba(18, 18, 18, 0.9);
        border-style: solid;
        border-color: var(--border-border-primary-10, rgba(166, 166, 166, 0.1));
        border-width: 0px 0px 1px 0px;
        padding: 0px 24px 0px 24px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: center;
        justify-content: space-between;
        height: 69px;
        position: relative;
        backdrop-filter: blur(50px);
        width: 100%;
        z-index: 9;
    }
    .frame-295922451 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        position: relative;
    }
    .frame-8 {
        display: flex;
        flex-direction: row;
        gap: 30px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011150 {
        flex-shrink: 0;
        width: 125px;
        height: 29.12px;
        position: relative;
    }
    .exclusion-7 {
        width: 98px;
        position: absolute;
        right: 75.82%;
        left: 0%;
        bottom: 7.64%;
        top: 0.2%;
        overflow: visible;
    }
    .bo {
        color: #ffffff;
        text-align: left;
        font-family: "SourGummy-Light", sans-serif;
        font-size: 23.47675323486328px;
        line-height: 23.72px;
        letter-spacing: -0.06em;
        font-weight: 300;
        position: absolute;
        right: 24.06%;
        left: 51.94%;
        width: 24%;
        bottom: 0%;
        top: 17.59%;
        height: 82.41%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .hey {
        color: #ffffff;
        text-align: left;
        font-family: "SourGummy-Light", sans-serif;
        font-size: 20.93349266052246px;
        line-height: 21.15px;
        letter-spacing: -0.06em;
        font-weight: 300;
        position: absolute;
        right: 47.18%;
        left: 26.42%;
        width: 26.4%;
        bottom: 0.66%;
        top: 23.8%;
        height: 75.54%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-313374 {
        background: #212121;
        border-radius: 4px;
        padding: 3px 2px 3px 2px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 21.6%;
        height: 44.64%;
        position: absolute;
        right: 0%;
        left: 78.4%;
        bottom: 55.36%;
        top: 0%;
    }
    .statuses {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .alert-text {
        color: var(--selected, #68efcf);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 8px;
        font-weight: 400;
        position: relative;
    }
    .search {
        background: #212121;
        border-radius: 50px;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 600px;
        height: 41px;
        position: relative;
        backdrop-filter: blur(50px);
        padding: 0px 12px;
        border: 1px solid transparent; /* Add this line */
        &:focus-within {
            border-color: #f7665f;
        }
    }
    .icon-main {
        height: 33px;
        width: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid rgba(166, 166, 166, 0.1);
        cursor: pointer;
    }
    .icon {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .spinner-img {
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
    .what-are-you-looking-for {
        color: #b5b5b5;
        text-align: left;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Italic", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        font-style: var(--button-text-medium-regular-font-style, italic);
        position: relative;
        flex: 1;
        padding-left: 10px;
        height: 33px;
    }
    .search-input-fields {
        height: 33px;
        background: transparent;
        border: none;
        width: 100%;
        outline: none;
        color: #fff;
    }
    .frame-295922452 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .header-nav-icons {
        border-radius: 10px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        position: relative;
        cursor: pointer;
    }
    .home-05 {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
    }
    .compass-03 {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
    }
    .header-nav-icons2.active {
        background: linear-gradient(270deg, rgba(247, 102, 95, 1) 0%, rgba(18, 18, 18, 1) 60%);
    }
    .header-nav-icons2 {
        background: linear-gradient(270deg, rgba(255, 255, 255, 0.1) 0%, rgba(18, 18, 18, 0) 100%);
        border-radius: 39px;
        padding: 0px 8px 0px 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .shopping-bag-03 {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        position: relative;
        overflow: visible;
    }
    ._0 {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--subtitle-1-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 16px);
        line-height: var(--subtitle-1-line-height, 24px);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .header-nav-icons3 {
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
    }
    .header-button {
        border-radius: 40px;
        border-style: solid;
        border-color: var(--buttons-button-secondary-active, #373737);
        border-width: 0.69px;
        flex-shrink: 0;
        width: 140px;
        height: 41px;
        position: relative;
        box-shadow: 2.78px 2.78px 60.74px 0px rgba(0, 0, 0, 1);
        cursor: pointer;
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 5.56px;
        align-items: center;
        justify-content: center;
        width: 141px;
        height: 20px;
        position: absolute;
        left: calc(50% - 71px);
        top: calc(50% - 8.5px);
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "ItcAvantGardeGothicProMd-Regular", sans-serif;
        font-size: 12px;
        line-height: 16.68px;
        font-weight: 400;
        position: relative;
        width: 137px;
        height: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .fireworks {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 100%;
        left: 0;
        pointer-events: none;
        overflow: hidden;
        z-index: 1;
    }

    .firework {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: explode 1s forwards;
    }

    @keyframes explode {
        0% {
            transform: scale(0);
            opacity: 1;
        }
        100% {
            transform: scale(1);
            opacity: 0;
        }
    }
    .heybo-ai-icon {
        height: 33px;
        width: 121px;
        border: 1px solid rgba(166, 166, 166, 0.2);
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        cursor: pointer;
        position: relative;
        z-index: 0;
    }
    .heybo-ai-icon span {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "ItcAvantGardeGothicProMd-Regular", sans-serif;
        font-size: 12px;
        line-height: 16.68px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .heybo-ai-icon:before {
        content: "";
        //background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
        background: linear-gradient(45deg, #7745e0, #68efcf, #5ac3fe, #5ac3fe, #68efcf, #7745e0);
        position: absolute;
        top: -2px;
        left: -2px;
        background-size: 400%;
        z-index: -1;
        filter: blur(5px);
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        animation: glowing 10s linear infinite;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        border-radius: 50px;
    }

    .heybo-ai-icon:hover:before {
        opacity: 1;
    }
    .heybo-ai-icon:after {
        z-index: -1;
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgb(5, 5, 5);
        left: 0;
        top: 0;
        border-radius: 50px;
    }

    @keyframes glowing {
        0% {
            background-position: 0 0;
        }
        50% {
            background-position: 400% 0;
        }
        100% {
            background-position: 0 0;
        }
    }
    @media (max-width: 768px) {
        &.transparent-header-homepage-only {
            height: 53px;
            padding: 0px 16px;
        }
        .group-1000011150 {
            width: 115px;
        }
        .exclusion-7 {
            width: 90px;
        }
    }
`;

export default function Header() {
    /* #region PROPS */
    const searchIsDisabled = true;
    /* #endregion PROPS */

    /* #region VARS */
    const navigate = useNavigate();
    const location = window.location.pathname;
    const {
        showRightCheckoutPanel,
        setShowBOImagePageID,
        setShowBOPicpageID,
        setShowRightCheckoutPanel,
        setShowRightAiPanel,
        setShowRightUserLocationPanel,
        setShowRightSettingsPanel,
        setShowLoginForm,
        setShowRegistration,
        showMenuPanel,
        setShowMenuPanel,
        setShowUserLoginRegisterPopup,
        isMobile,
        setShowRightMyOrdersPanel,
        setShowRightMyOrdersDetailsPanel,
        setShowYourAccountPannel,
        homeLoge,
        feedLogo,
        setHomeLogo,
        setFeedLogo,
        setShowPersonalInformation,
        setShowCardInformation,
        fireworks,
        showFireWorks,
        setStripeCardData,
        setSelectedType,
        setOnFocusSearchBox,
        setShowFilterBox,
        searchText,
        setSearchText,
        setSelectedPaymentType
    } = React.useContext(LayoutContext);
    const {
        isUserLoggedIn,
        setIsUserLoggedIn,
        setUserData,
        setUserAddress,
        setUserGPSCoordinates,
        checkoutCartData,
        setCheckoutCartData,
        setCheckoutPaymentData,
        setBOTagAccountID,
        setShippingRecipient,
        setUserPaymentMethods
    } = React.useContext(UserContext);
    const { setDefaultNotificationCard } = React.useContext(StandardsContext);
    const { setSelectedBrandID, shopperBagItem, setShopperBagID, setShopperBagItem } = React.useContext(AppContext);

    const [isFocused, setIsFocused] = useState(false);
    const [showSearchWindow, setShowSearchWindow] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const searchBoxRef = useRef(null);
    const [searchData, setSeachData] = useState({ brands: [], items: [] });
    /* #endregion */

    /* #region METHODS */
    const gotoHomeFun = () => {
        navigate("/");
        setShowBOImagePageID("");
        setShowRightUserLocationPanel(false);
        setShowRightCheckoutPanel(false);
        setShowRightMyOrdersPanel(false);
        setShowRightAiPanel(false);
        setShowRightMyOrdersDetailsPanel({
            orderID: null,
            isOpen: false
        });
        setShowRightSettingsPanel(false);
        setShowYourAccountPannel(false);
        const element = document.querySelector(".main");
        if (element) {
            element.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    const gotoFeedFun = () => {
        setHomeLogo(false);
        setFeedLogo(true);
        navigate("/explore");
        setShowBOImagePageID("");
        setShowBOPicpageID("");
        setShowRightUserLocationPanel(false);
        setShowRightCheckoutPanel(false);
        setShowRightMyOrdersPanel(false);
        setShowRightAiPanel(false);
        setShowRightMyOrdersDetailsPanel({
            orderID: null,
            isOpen: false
        });
        setShowRightSettingsPanel(false);
        setShowYourAccountPannel(false);
        setSelectedBrandID("");
        setSelectedType("Posts");
    };
    const CheckoutClicked = () => {
        logGA4Event("Checkout_Loading");
        setShowRightCheckoutPanel(true);
        setShowRightSettingsPanel(false);
        setShowRightAiPanel(false);
        logGA4Event("Checkout_Shown");
    };
    const profileBtnClicked = () => {
        logGA4Event("MainMenu");
        setShowMenuPanel(true);
        setShowRightAiPanel(false);
    };

    const onLoginClicked = () => {
        logGA4Event("Login");
        setShowUserLoginRegisterPopup(true);
        setShowLoginForm(true);
        setShowRegistration(false);
        setShowPersonalInformation(false);
        setShowCardInformation(false);
    };
    const createAccountFun = () => {
        logGA4Event("CreateYourBOaccount");
        setShowUserLoginRegisterPopup(true);
        setShowLoginForm(false);
        setShowRegistration(true);
    };

    const onLogout = () => {
        userLogout(
            setIsUserLoggedIn,
            setUserData,
            setUserAddress,
            setUserGPSCoordinates,
            setCheckoutCartData,
            setCheckoutPaymentData,
            setBOTagAccountID,
            setShippingRecipient,
            setUserPaymentMethods,
            setSelectedPaymentType
        );
        setStripeCardData({
            isCardNumber: false,
            isCardExpData: false,
            isCardCvv: false,
            isComplete: false
        });
        if (location === "/explore" || location === "/") {
            setShowRightUserLocationPanel(false);
        } else {
            setShowRightUserLocationPanel(true);
        }
        setShowRightCheckoutPanel(false);
        setShowRightMyOrdersPanel(false);
        setShowRightAiPanel(false);
        setShowRightMyOrdersDetailsPanel({
            orderID: null,
            isOpen: false
        });
        setShowRightSettingsPanel(false);
        setShowYourAccountPannel(false);

        setShopperBagID(null);
        setShopperBagItem([]);
        localStorage.removeItem("shopperBag");
        //Library.showSuccessMessage("You have been logged out.");

        Library.showNotification({
            message: "You have been logged out.",
            type: "success",
            setDefaultNotificationCard
        });
    };
    const handleFocus = () => {
        setIsFocused(true);
        setOnFocusSearchBox(true);
    };
    const handleInputChange = e => {
        setSearchText(e.target.value);

        if (e.target.value) {
            getSeachResult(e.target.value);
        } else {
            setShowSearchWindow(false);
            setSeachData({ brands: [], items: [] });
        }
    };
    const getSeachResult = searchTitle => {
        setIsSearching(true);
        Library.makePostRequest(
            "searchData",
            {
                searchTitle: searchTitle
            },
            false
        )
            .then(response => {
                const { data } = response.data;
                setSeachData(data);
                setShowSearchWindow(true);
                setIsSearching(false);
            })
            .catch(error => {
                console.log(error);
            });
    };
    const clearInput = () => {
        setSearchText("");
        setShowSearchWindow(false);
        setOnFocusSearchBox(false);
        setShowFilterBox(false);
        //navigate("/explore");
    };
    const gotoTop = () => {
        const element = document.querySelector(".main");
        if (element) {
            element.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    /* #endregion METHODS */

    /* #region EFFECTS */

    const handleClickOutside = event => {
        if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
            setShowSearchWindow(false);
            setOnFocusSearchBox(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    React.useEffect(() => {
        if (showFireWorks) {
            const fireworksContainer = document.getElementById("fireworks");
            fireworks.forEach(firework => {
                const fireworkElement = document.createElement("div");
                fireworkElement.classList.add("firework");
                fireworkElement.style.left = firework.left;
                fireworkElement.style.top = firework.top;
                fireworkElement.style.background = `radial-gradient(circle, rgba(255,255,255,0) 50%, ${firework.color} 100%)`;
                fireworkElement.style.width = `${firework.size}px`;
                fireworkElement.style.height = `${firework.size}px`;
                fireworksContainer.appendChild(fireworkElement);

                fireworkElement.addEventListener("animationend", () => {
                    fireworkElement.remove();
                });
            });
        }
    }, [fireworks, showFireWorks]);

    /* #endregion */

    return (
        <StyledPage className="transparent-header-homepage-only">
            <div
                className="frame-295922451"
                style={{
                    display: "flex",
                    justifyContent: "flex-end",

                    flexShrink: 0
                }}>
                <div className="frame-8">
                    <Link to="/" onClick={gotoTop}>
                        <div className="group-1000011150">
                            <img className="exclusion-7" src={HeyBOLogo} alt="exclusion-70.svg" />
                            <div className="frame-313374">
                                <div className="statuses">
                                    <div className="alert-text">BETA</div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div
                className="search"
                style={{
                    /*
                    opacity: feedLogo ? 1 : 0,
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "auto",
                    minWidth: "600px" // Add this line
                    */
                    display: feedLogo ? "flex" : "none",
                    width: "600px",
                    justifyContent: "center",
                    flexShrink: 1,
                    flexBasis: "100%",
                    maxWidth: "600px",
                    opacity: searchIsDisabled ? 0.4 : 1,
                    cursor: searchIsDisabled ? "not-allowed" : "unset"
                }}
                ref={searchBoxRef}>
                <div className="what-are-you-looking-for">
                    <input
                        type="text"
                        disabled={searchIsDisabled}
                        style={{ opacity: searchIsDisabled ? 1 : 1, cursor: searchIsDisabled ? "not-allowed" : "unset" }}
                        className="search-input-fields"
                        placeholder="What are you looking for?"
                        value={searchText}
                        onChange={handleInputChange}
                        onFocus={handleFocus}
                    />
                </div>
                <div className="icon-main" style={{ cursor: searchIsDisabled ? "not-allowed" : "unset" }}>
                    {searchText && !searchIsDisabled ? (
                        isSearching ? (
                            <img src={Spiner} alt="ClearSearch" className="icon spinner-img" />
                        ) : (
                            <img className="icon" src={ClearSearch} alt="ClearSearch" onClick={clearInput} />
                        )
                    ) : (
                        <img
                            className="icon"
                            src={ExploreSearch}
                            alt="ExploreSearch"
                            style={{ cursor: searchIsDisabled ? "not-allowed" : "unset" }}
                        />
                    )}
                </div>
                <Tooltip placement="bottom" title={""} color="#212121">
                    <div className="heybo-ai-icon" onClick={() => setShowRightAiPanel(true)}>
                        <img className="icon" src={AiSeacrhIcon} alt="icon0.svg" />
                        <span>Ask HeyBO</span>
                    </div>
                </Tooltip>
                {showSearchWindow && (
                    <SearchWindow
                        searchText={searchText}
                        setSearchText={setSearchText}
                        setShowSearchWindow={setShowSearchWindow}
                        setOnFocusSearchBox={setOnFocusSearchBox}
                        searchData={searchData}
                    />
                )}
            </div>
            <div
                className="frame-295922452"
                style={{
                    display: "flex",
                    justifyContent: "flex-end",

                    flexShrink: 1
                }}>
                <div className="header-nav-icons" onClick={gotoHomeFun}>
                    <img className="home-05" src={homeLoge ? HomeIcon : InActiveHomeIcon} alt="HomeIcon" />
                </div>
                <div className="header-nav-icons" onClick={gotoFeedFun}>
                    <img className="compass-03" src={feedLogo ? ActiveExploreIcon : ExploreIcon} alt="compass-030.svg" />
                </div>
                <div className={`header-nav-icons2 ${shopperBagItem?.length ? "active" : ""}`} onClick={CheckoutClicked}>
                    <img className="shopping-bag-03" src={CartBagIcon} alt="shopping-bag-030.svg" />
                    <div className="_0">{shopperBagItem?.length}</div>
                    <div className="fireworks" id="fireworks"></div>
                </div>

                <div className="header-nav-icons">
                    {isUserLoggedIn ? (
                        <img className="frame-29159  loggedin" src={MenuProfile} alt="Profile" onClick={profileBtnClicked} />
                    ) : (
                        <img className="header-nav-icons3" src={LoginIcon} alt="header-nav-icons3.svg" onClick={onLoginClicked} />
                    )}
                    {showMenuPanel && <MenuPanel onLogout={onLogout} />}
                </div>

                {!isUserLoggedIn && !isMobile && (
                    <div className="header-button" onClick={createAccountFun}>
                        <div className="frame-29590">
                            <div className="button">Create account</div>
                        </div>
                    </div>
                )}
            </div>
        </StyledPage>
    );
}
